import {Funcionario} from "@/models/Funcionario";
import {Cajero} from "@/models/Cajero";
import {Cifrado} from "@/addons/Cifrado";

export class UserAuth {
    constructor(
        public id: number = 0,
        public email: string = '',
        public nombre_completo: string = '',
        public rol: string = '',
        public alta: boolean = false,
        public funcionario_id: number = 0,
        public funcionario: Funcionario = new Funcionario(),
        public cajero: Cajero = new Cajero()
    ) {
    }

    public static can(slug: string) {
        const permisos = JSON.parse(localStorage.getItem("permisos")!);
        return permisos?.find((x:any) => Cifrado.decrypt(x.slug) === slug) !== undefined;
    }

    public static isLogin(): boolean
    {
        return localStorage.getItem('token_cajas') !== null
    }
}